import React from "react";
import Dropdown from "../../FormFields/DropdownSingleSelection";
const MessageA13s = (props) => {
  return <Dropdown {...props} />;
};
export default MessageA13s;